import { storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const productListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.Products,
    operation: EnumOperation.add_edit_product,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.Products,
    operation: EnumOperation.view_all_product_listing_page,
  }),
];

const productDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.Products,
    operation: EnumOperation.add_edit_product,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.Products,
    operation: EnumOperation.delete_product,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.Products,
    operation: EnumOperation.view_product_details_page,
  }),
];

const stockListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsStockIn,
    operation: EnumOperation.add_stock,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsStockIn,
    operation: EnumOperation.view_stock_listing_page,
  }),
];

const stockDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsStockIn,
    operation: EnumOperation.add_stock,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsStockIn,
    operation: EnumOperation.view_stock_details,
  }),
];

const inventoryListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsInventory,
    operation: EnumOperation.edit_inventory,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsInventory,
    operation: EnumOperation.view_inventory_listing_page,
  }),
];

const inventoryDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsInventory,
    operation: EnumOperation.edit_inventory,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsInventory,
    operation: EnumOperation.view_inventory_history,
  }),
];

const reviewListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.add_edit_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.delete_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.publish_unpublish_archive,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.reply_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.view_all_product_review_listing_page,
  }),
];

const reviewDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.add_edit_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.delete_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.publish_unpublish_archive,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.reply_review,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Products,
    subCategory: EnumSubCategory.ProductsReview,
    operation: EnumOperation.view_product_details_page,
  }),
];

const voucherListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.view_voucher_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.add_edit_voucher,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.archive_publish_unpublish,
  }),
];

const voucherDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.view_voucher_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.add_edit_voucher,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Voucher,
    subCategory: EnumSubCategory.StoreVoucher,
    operation: EnumOperation.archive_publish_unpublish,
  }),
];

const allCustomersGridPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDatabaseGeneral,
    operation: EnumOperation.view_all_customer_database_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDatabaseGeneral,
    operation: EnumOperation.create_database,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDatabaseGeneral,
    operation: EnumOperation.rename_database,
  }),
];

const customerListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerGeneral,
    operation: EnumOperation.view_all_customers_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerGeneral,
    operation: EnumOperation.add_customer,
  }),
];

const customerDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDetailsPage,
    operation: EnumOperation.access_page_and_view_customer_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDetailsPage,
    operation: EnumOperation.send_account_invite,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDetailsPage,
    operation: EnumOperation.subscribe_customer,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDetailsPage,
    operation: EnumOperation.delete_subscription,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDetailsPage,
    operation: EnumOperation.erase_customer_data,
  }),
];

const dbSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDatabaseSetting,
    operation: EnumOperation.view_customer_database_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerDatabaseSetting,
    operation: EnumOperation.edit_and_save,
  }),
];

const tagListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerTagGeneral,
    operation: EnumOperation.view_customer_tags_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerTagGeneral,
    operation: EnumOperation.add_tag,
  }),
];

const tagDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerTagDetailsPage,
    operation: EnumOperation.view_customer_tag_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerTagDetailsPage,
    operation: EnumOperation.edit_tag,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Customers,
    subCategory: EnumSubCategory.CustomerTagDetailsPage,
    operation: EnumOperation.delete_tag,
  }),
];

const salesChannelGridPage = [
  storeResourceNameGenerator({
    category: EnumCategory.General,
    subCategory: EnumSubCategory.StoreChannel,
    operation: EnumOperation.create_duplicate_sales_channel,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.General,
    subCategory: EnumSubCategory.StoreChannel,
    operation: EnumOperation.rename_sales_channel,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.General,
    subCategory: EnumSubCategory.StoreChannel,
    operation: EnumOperation.delete_sales_channel,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.General,
    subCategory: EnumSubCategory.StoreChannel,
    operation: EnumOperation.view_all_sales_channel_listing_page,
  }),
];

const ordersListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.AllOrders,
    operation: EnumOperation.view_all_orders_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.AllOrders,
    operation: EnumOperation.view_order_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.create_edit_order,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.place_order,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.delete_order_portal_created_order,
  }),
];

const orderDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.AllOrders,
    operation: EnumOperation.view_order_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderFulfillment,
    operation: EnumOperation.pick_pack_ship,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCustomer,
    operation: EnumOperation.view_edit_customer_info,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderPayment,
    operation: EnumOperation.mark_as_paid_bank_transfer,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderPayment,
    operation: EnumOperation.mark_as_paid_manual,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.create_edit_refund,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.confirm_refund,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.reject,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.approve,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.process_refund,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderRefund,
    operation: EnumOperation.mark_as_refunded,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderReturn,
    operation: EnumOperation.create_edit_return,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderReturn,
    operation: EnumOperation.reject,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderReturn,
    operation: EnumOperation.approve,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderReturn,
    operation: EnumOperation.mark_as_returned,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCancellation,
    operation: EnumOperation.cancel_order,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderAdditionalItem,
    operation: EnumOperation.create_edit_request,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderAdditionalItem,
    operation: EnumOperation.reject,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderAdditionalItem,
    operation: EnumOperation.approve,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderAdditionalPromoCode,
    operation: EnumOperation.add,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderAdditionalPromoCode,
    operation: EnumOperation.remove,
  }),

  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.create_edit_order,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.place_order,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCreation,
    operation: EnumOperation.delete_order_portal_created_order,
  }),
];

const subscriptionBuyListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.view_subscription_buy_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.view_subscription_buy_details_page,
  }),
];

const subscriptionBuyDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.view_subscription_buy_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.edit_quantity,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.edit_customer,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderSubscription,
    operation: EnumOperation.cancel_subscription,
  }),
];

const shoppingCartTemplateListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.view_shopping_cart_template_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.view_shopping_cart_template_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.create_edit_shopping_cart_template,
  }),
];

const shoppingCartTemplateDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.view_shopping_cart_template_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.notify_customer,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.switch_status,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.create_edit_shopping_cart_template,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderCartTemplate,
    operation: EnumOperation.delete_shopping_cart_template,
  }),
];

const giftCardListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.view_gift_card_store_credit_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.view_gift_card_store_credit_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.edit_email_mobile,
  }),
];

const giftCardDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.view_gift_card_store_credit_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.edit_email_mobile,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.switch_status,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Order,
    subCategory: EnumSubCategory.OrderGiftCard,
    operation: EnumOperation.resend_notification,
  }),
];

const settingGridPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsView,
    operation: EnumOperation.view_all_settings_page,
  }),
];

const fileLibraryListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.view_file_library_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.upload_and_edit_file,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.delete_file,
  }),
];

const fileLibraryDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.view_file_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.upload_and_edit_file,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsFileLibrary,
    operation: EnumOperation.delete_file,
  }),
];

const linkLibraryListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.view_link_library_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.create_edit_link,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.delete_link,
  }),
];

const linkLibraryDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.view_link_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.create_edit_link,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLinkLibrary,
    operation: EnumOperation.delete_link,
  }),
];

const storeDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsStoreDetails,
    operation: EnumOperation.view_store_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsStoreDetails,
    operation: EnumOperation.edit_setting,
  }),
];

const developerPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsDeveloperSetting,
    operation: EnumOperation.view_developer_setting,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsDeveloperSetting,
    operation: EnumOperation.create_access_key,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsDeveloperSetting,
    operation: EnumOperation.delete_access_key,
  }),
];

const invoicePage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsInvoice,
    operation: EnumOperation.view_invoice_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsInvoice,
    operation:
      EnumOperation.edit_setting_preview_test_invoice_print_test_invoice,
  }),
];

const currencyPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCurrency,
    operation: EnumOperation.view_currency_setting,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCurrency,
    operation: EnumOperation.edit_setting,
  }),
];

const productSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsProduct,
    operation: EnumOperation.view_product_setting,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsProduct,
    operation: EnumOperation.edit_setting,
  }),
];

const orderSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsOrder,
    operation: EnumOperation.view_order_setting,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsOrder,
    operation: EnumOperation.edit_setting,
  }),
];

const taxListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.view_all_tax_rule_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.add_edit_tax_rule,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.delete_tax_rule,
  }),
];

const taxDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.view_tax_rule_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.add_edit_tax_rule,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsTaxes,
    operation: EnumOperation.delete_tax_rule,
  }),
];

const logisticsWarehouseSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.deactivate_warehouse,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.add_edit_warehouse_information,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_warehouse_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_courier_account_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_delivery_method_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_parcel_lockers_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_packing_slip_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.edit_pick_pack_process_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation:
      EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.customise_packing_slip,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.preview_test_packing_slip,
  }),
];

const logisticsWarehouseParcelLockerSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_parcel_lockers_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation:
      EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
  }),
];

const logisticsWarehouseCourierAccountSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_courier_account_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation:
      EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
  }),
];

const logisticsWarehouseDeliverMethodSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_delivery_method_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation:
      EnumOperation.add_edit_courier_account_parcel_locker_delivery_method,
  }),
];

const logisticsWarehousePackingSlipSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_parcel_lockers_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.view_packing_slip_setting_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.edit_pick_pack_process_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.customise_packing_slip,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
    operation: EnumOperation.preview_test_packing_slip,
  }),
];

const shoppingZonePage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsShippingZone,
    operation: EnumOperation.add_edit_shipping_zone,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsShippingZone,
    operation: EnumOperation.delete_shipping_zone,
  }),
];

const pickupLocationPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
    operation: EnumOperation.add_edit_click_and_collect_pickup_location,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
    operation: EnumOperation.delete_click_and_collect_pickup_location,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
    operation: EnumOperation.view_click_and_collect_pickup_location_details,
  }),
];

const packagePage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPackages,
    operation: EnumOperation.add_edit_packages,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPackages,
    operation: EnumOperation.delete_packages,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsPackages,
    operation: EnumOperation.view_packages_details,
  }),
];

const destinationPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory:
      EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
    operation: EnumOperation.edit_destinationaddress_localisation_setting,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory:
      EnumSubCategory.SettingsLogisticsDestinationAddressLocalisation,
    operation: EnumOperation.view_destinationaddress_localisation_setting,
  }),
];

const logisticsSettingPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLogisticsAllLogisticsSettings,
    operation: EnumOperation.view_all_logistics_settings_page,
  }),
  ...logisticsWarehouseSettingPage,
  ...pickupLocationPage,
  ...packagePage,
  ...destinationPage,
  ...shoppingZonePage,
];

const paymentListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.add_edit_payment_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.delete_payment_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.view_payment_gateways_listing_page,
  }),
];

const paymentDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.view_payment_gateway_details,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.add_edit_payment_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.delete_payment_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsPayment,
    operation: EnumOperation.copy_webhook,
  }),
];

const localizationPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLocalisation,
    operation: EnumOperation.view_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsLocalisation,
    operation: EnumOperation.edit_setting,
  }),
];

const thirdPartyPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsThirdParty,
    operation: EnumOperation.view_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsThirdParty,
    operation: EnumOperation.edit_setting,
  }),
];

const tagManagementPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsStoreTagManager,
    operation: EnumOperation.view_store_tags,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsStoreTagManager,
    operation: EnumOperation.add_edit_tag,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsStoreTagManager,
    operation: EnumOperation.delete_tag,
  }),
];

const userPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsUserPermission,
    operation: EnumOperation.view_settings,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsUserPermission,
    operation: EnumOperation.add_edit_user,
  }),
];

const communicationListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.view_communication_gateways_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.add_edit_communication_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.delete_communication_gateway,
  }),
];

const communicationDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.view_communication_gateway_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.add_edit_communication_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.delete_communication_gateway,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.add_edit_template,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Settings,
    subCategory: EnumSubCategory.SettingsCommunication,
    operation: EnumOperation.delete_template,
  }),
];

const communicationAuditTrailListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Communication,
    subCategory: EnumSubCategory.CommunicationAuditTrail,
    operation: EnumOperation.view_communication_audit_trail_listing_page,
  }),
];

const communicationAuditTrailDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Communication,
    subCategory: EnumSubCategory.CommunicationAuditTrail,
    operation: EnumOperation.view_communication_audit_trail_details_page,
  }),
];

const analyticsDashboardPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsDashboard,
    operation: EnumOperation.view_dashboard,
  }),
];

const analyticsSubscriptionListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.view_report_subscription_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.view_report_subscription_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.add_edit_report_subscription,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.delete_report_subscription,
  }),
];

const analyticsSubscriptionDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.view_report_subscription_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.view_report_subscription_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.add_edit_report_subscription,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReportSubscription,
    operation: EnumOperation.delete_report_subscription,
  }),
];

const analyticsReportListPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.view_report_listing_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.add_edit_report,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.delete_report,
  }),
];

const analyticsReportDetailPage = [
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.view_report_details_page,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.add_edit_report,
  }),
  storeResourceNameGenerator({
    category: EnumCategory.Analytics,
    subCategory: EnumSubCategory.AnalyticsReports,
    operation: EnumOperation.delete_report,
  }),
];

export {
  communicationDetailPage,
  communicationListPage,
  userPage,
  tagManagementPage,
  thirdPartyPage,
  localizationPage,
  paymentDetailPage,
  paymentListPage,
  logisticsSettingPage,
  destinationPage,
  packagePage,
  shoppingZonePage,
  pickupLocationPage,
  logisticsWarehouseSettingPage,
  logisticsWarehouseCourierAccountSettingPage,
  logisticsWarehousePackingSlipSettingPage,
  logisticsWarehouseDeliverMethodSettingPage,
  logisticsWarehouseParcelLockerSettingPage,
  taxDetailPage,
  taxListPage,
  orderSettingPage,
  productSettingPage,
  currencyPage,
  invoicePage,
  developerPage,
  storeDetailPage,
  linkLibraryDetailPage,
  linkLibraryListPage,
  fileLibraryDetailPage,
  fileLibraryListPage,
  settingGridPage,
  giftCardDetailPage,
  giftCardListPage,
  shoppingCartTemplateDetailPage,
  shoppingCartTemplateListPage,
  subscriptionBuyDetailPage,
  subscriptionBuyListPage,
  orderDetailPage,
  ordersListPage,
  salesChannelGridPage,
  tagDetailPage,
  tagListPage,
  dbSettingPage,
  customerDetailPage,
  customerListPage,
  allCustomersGridPage,
  voucherDetailPage,
  voucherListPage,
  reviewDetailPage,
  reviewListPage,
  inventoryDetailPage,
  inventoryListPage,
  stockDetailPage,
  stockListPage,
  productDetailPage,
  productListPage,
  communicationAuditTrailListPage,
  communicationAuditTrailDetailPage,
  analyticsDashboardPage,
  analyticsSubscriptionListPage,
  analyticsSubscriptionDetailPage,
  analyticsReportListPage,
  analyticsReportDetailPage,
};
